// extracted by mini-css-extract-plugin
export default {"app":"OtherArea_app__TnDGv","headerBar":"OtherArea_headerBar__i0WeL","view":"OtherArea_view__kSZpY","rightTool":"OtherArea_rightTool__fONyQ","test":"OtherArea_test__MROkG"};